
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteB as ObiOwnShipRemoteBElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-b.js';
 
 
 

 
 export const ObiOwnShipRemoteB = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-b',
   elementClass: ObiOwnShipRemoteBElement,
   events: {
     
   }
  });
 
 